import { DefaultFormatRegistry } from '@cs/common';

export class VanVlietFormatRegistry extends DefaultFormatRegistry {

	constructor() {
		super();
		this.options.nullAsZero = false;
	}
}